import { Notifications, setNotification, useSignalR } from '@/composables';
import { useVersionStore } from '@/store/version.store';
import { App } from 'vue';
export default {
    install: async (app: App) => {
        const versionStore = useVersionStore();
        const signalR = useSignalR('/ws/notify', {
            Notification: (message: string) => {
                setNotification(message);
                Notifications.Info(message);
            },
            ReleasedVersion: (version: string) => {
                versionStore.setReleasedVersion(version);
            },
        });

        await signalR.startConnection();
        app.config.globalProperties.$signalR = signalR;
    },
};
